var giphy_viewer_default = {
  "giphyWrapper": "aQHg6",
  "giphy_player": "MPNr5",
  "playIcon": "IWcn7",
  "gifRatio": "TCF1E"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
